import * as React from 'react';

const AuthenticityDiamondMultichome16Dark = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#449DA9",
    d: "M11.753 2H4.307a.867.867 0 0 0-.62.269L.49 5.692a.853.853 0 0 0 0 1.184l6.914 6.875a.841.841 0 0 0 .919.182.841.841 0 0 0 .273-.182l6.915-6.875a.853.853 0 0 0 0-1.184l-3.197-3.423A.864.864 0 0 0 11.753 2Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "m11.352 5.702 1.613.328a.321.321 0 0 1 .241.308.317.317 0 0 1-.24.309l-1.614.318-.33 1.602a.318.318 0 0 1-.311.24.322.322 0 0 1-.311-.24l-.32-1.602-1.614-.318a.32.32 0 0 1-.241-.309.317.317 0 0 1 .241-.308l1.613-.328L10.4 4.1a.318.318 0 0 1 .31-.24.322.322 0 0 1 .311.24l.33 1.602Z"
  }
));
AuthenticityDiamondMultichome16Dark.Size = 16;
AuthenticityDiamondMultichome16Dark.Title = "AuthenticityDiamondMultichome";

export { AuthenticityDiamondMultichome16Dark as default };
